import { roundedClassname } from '@/helpers/environmentHelper';
import { useAppDispatch, useAppSelector } from '@/state/hooks';
import {
    openNotifications,
    selectNotificationsOpened,
    setNotificationsVisited
} from '@/state/reducers/notificationSlice';
import { UseDisclosureReturn } from '@/utils/hooks/useDisclosure';
import cn from 'classnames';
import { MdMenu } from 'react-icons/md';
import NotificationButton from '../common/NotificationButton';

interface MobileNavbarProps {
    drawerDisclosure: UseDisclosureReturn;
}

const MobileNavbar = ({ drawerDisclosure }: MobileNavbarProps) => {
    const dispatch = useAppDispatch();
    const notificationsOpened = useAppSelector(selectNotificationsOpened);

    return (
        <div className="flex lg:hidden h-full gap-1 mr-1">
            <NotificationButton
                size="w-6 h-6"
                isActive={notificationsOpened}
                onClick={() => {
                    dispatch(openNotifications());
                    dispatch(setNotificationsVisited(true));
                }}
            />
            <MobileDrawerButton drawerDisclosure={drawerDisclosure} />
        </div>
    );
};

export default MobileNavbar;

export const MobileDrawerButton = ({ drawerDisclosure }: MobileNavbarProps) => {
    return (
        <button
            type="button"
            className={cn(
                'inline-flex p-2 my-1 items-center justify-center bg-brand-background border border-brand-neutral-700 text-brand-text focus:outline-none transition duration-150 ease-in-out',
                roundedClassname
            )}
            onClick={drawerDisclosure[1].toggle}>
            <MdMenu className="w-6 h-6" />
        </button>
    );
};
